import { Injectable } from "@angular/core";
import { IObjectKey, IPlatformUser } from "@nova/common-interfaces";
import { FUNCTION_NAME } from "@rfm/shared-interfaces";
import { CommonReadOnlyService } from "../common/common-readonly.service.mjs";

@Injectable({ providedIn: "root" })
export class UserListService extends CommonReadOnlyService<IPlatformUser, IObjectKey> {
  // #region Properties (6)

  public override getAllFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GETALL;
  public override getFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GET;
  public override getKeysFunctionName: FUNCTION_NAME = FUNCTION_NAME.PLATFORM_USER_GETKEYS;

  // #endregion Properties (6)

  // #region Public Methods (1)

  public async refresh(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // #endregion Public Methods (1)
}
